<template>
  <div class="ma-4">
  <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
  <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
            <v-flex xs12>
              <v-btn fab x-small @click="$router.go(-1)">
                <v-icon>navigate_before</v-icon>
                  
                </v-btn>
            </v-flex>

            <!-- <v-flex xs12 md1 class="mb-2">
              <v-btn 
                  fab 
                  small
                  @click="printTable()"
                  class="ml-8 white--text"
                  color="#2b6993"
                  elevation="4"
                  absolute 
                  right
                  >
                  <v-icon>print</v-icon>
              </v-btn>
              
            </v-flex> -->

            <v-flex xs12 md1>
              
            </v-flex>

            <v-flex xs12>
              <h3 class="text-center mb-5">Billing Report</h3>
              <v-divider class="ml-4 mr-4 mb-3"></v-divider>
            </v-flex>

            
            <v-flex xs12 md2 class="ml-4 pa-1">
                <v-autocomplete
                  :items="months"
                  v-model="newMonth"
                  label="Select Month"
                ></v-autocomplete>

            </v-flex>

            <v-flex xs12 md2 class="pa-1 hideOnPrint">
              <v-autocomplete
                  v-model="newYear"
                  label="Select Year"
                ></v-autocomplete>
            </v-flex>

            <v-flex xs12 md3 class="pa-1 mb-2 hideOnPrint">
                <v-select
                    label="Select a Client"
                    :items="clients"
                    item-text="Name"
                    item-value="_id"
                    v-model="clientID"
                    clearable
                    :required="requiredField"
                ></v-select>
            </v-flex>

            <v-flex xs12 md2 class="pa-1 mb-2 hideOnPrint">
                <v-select
                    label="Select Report"
                    :items="reports"
                    v-model="newReport"
                    clearable
                    :required="requiredField"
                ></v-select>
            </v-flex>

            <v-flex xs12 md2 class="mt-5 mb-5 pl-5">
              <v-btn
                  small
                  @click="getQueryData()"
                  class="ma-1"

              >Search
              </v-btn>
            </v-flex>

            <v-flex xs12 class="pa-2">
                <v-data-table
                  :headers="headers"
                  :items="billings"
                  sort-by="StartDate"
                  sort-asc
                  class="elevation-1"
                  :loading="isLoading"
                  loading-text="Loading Client Billing"
                  :items-per-page="100"
                >
                <template v-slot:item.Status="{ item }">
                  <v-chip
                      :color="getStatusColor(item.Status)"
                      dark
                      small
                  >
                      {{ item.Status }}
                  </v-chip>
                  </template>
                <template v-slot:item.select="{ item }">
                    <v-btn
                      x-small
                      class="white--text"
                      color="#2b3990"
                      @click="viewBillingReport(item)"
                    >
                      View
                    </v-btn>
                  <v-icon
                      small
                      class="ml-4"
                      @click="downloadBillingReport(item.PDFUrl)"
                  >
                    mdi-download
                  </v-icon>
                  <v-icon
                    small
                    class="ml-4"
                    @click="deleteBilling(item)"
                    title="Delete"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                </v-data-table>

                <v-dialog v-model='dialog' max-width="90%">
                  <v-card>
                    <v-card-title style="background-color: #2b3990">
                      <span class="headline white--text">{{ titleForm  }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form
                        ref="form"
                        lazy-validation>
                        <v-container>
                          <v-row>
                             <v-col cols="12" md="4">
                                  <v-text-field
                                      label="Client"
                                      v-model="newClient"
                                      readonly
                                  ></v-text-field>
                             </v-col>
                             <v-col cols="12" md="4">
                                  <v-text-field
                                      label="Month"
                                      v-model="newMonth"
                                      readonly
                                  ></v-text-field>
                             </v-col>
                             <v-col cols="12" md="4">
                                  <v-text-field
                                      label="Year"
                                      v-model="newYear"
                                      readonly
                                  ></v-text-field>
                             </v-col>
                             <v-col cols="12" md="6">
                                  <v-text-field
                                      label="Start Date"
                                      v-model="newStartDate"
                                      readonly
                                  ></v-text-field>
                             </v-col>
                             <v-col cols="12" md="6">
                                  <v-text-field
                                      label="End Date"
                                      v-model="newEndDate"
                                      readonly
                                  ></v-text-field>
                             </v-col>
                             <v-col cols="12" md="6">
                                  <v-switch
                                      label="Complete"
                                      value="Complete"
                                      v-model="newStatus"
                                  ></v-switch>
                                  <v-switch
                                      label="Incomplete"
                                      value="Incomplete"
                                      v-model="newStatus"
                                  ></v-switch>
                             </v-col>
                             <v-col cols="12">
                                  <v-text-field
                                      label="CreatedBy"
                                      v-model="newCreatedBy"
                                      readonly
                                  ></v-text-field>
                             </v-col>

                             <v-col cols="12">
                              <LoadPDF :pdfFile="PDFUrl"/>
                             </v-col>
                        </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1"  class="white--text" @click="updateBilling()">Update</v-btn>
                      <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
      </v-card>

      <div id="print">
        <h2 class="text-center ma-3">Nevada Client Billing Report</h2>
        <v-row>
          <v-col cols="12" md="4">
              <v-text-field
                  label="Client"
                  v-model="newClient"
              ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
              <v-text-field
                  label="Month"
                  v-model="newMonth"
              ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
              <v-text-field
                  label="Year"
                  v-model="newYear"
              ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
              <v-text-field
                  label="Start Date"
                  v-model="newStartDate"
              ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
              <v-text-field
                  label="End Date"
                  v-model="newEndDate"
              ></v-text-field>
          </v-col>
          <v-col cols="12">
              <v-text-field
                  label="CreatedBy"
                  v-model="newCreatedBy"
              ></v-text-field>
          </v-col>
      </v-row>
      </div>
  </div>
</template>
<script>
import axios from 'axios'
import LoadPDF from "@/components/LoadPDF.vue";
// import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

// const NevadaIncidentService = require('../../service/nevada-incident.service');

export default {
  components: {
      LoadPDF
  },
  data: () => ({
    headers: [
      {
        text: 'Client',
        align: 'start',
        sortable: true,
        value: 'Client.Name',
      },
      { text: "Month", value: "Month" },
      { text: "Year", value: "Year" },
      { text: "Start Date", value: "StartDate" },
      { text: "End Date", value: "EndDate" },
      { text: "Report", value: "Report" },
      { text: "Created", value: "CreatedBy" },
      { text: "Status", value: "Status" },
      { text: "Action", value: "select" },

      // { text: "Actions", value: "actions", sortable: false },
    ],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    dialog: false,
    search: "",
    msg: false,
    text:"",
    units: [],
    users: [],
    staff: "",
    codes: [],
    tempData: [],
    clientID: '',
    userID: localStorage.getItem("userID"),
    unitID: localStorage.getItem('unitID'),
    requiredField: [
        v => !!v || 'This is required',
    ],
    url: require("../../client_config/config").url,
    states: ["Utah", "Nevada"],
    userState: localStorage.getItem('userState'),
    isLoading: false,
    ClientID: "",
    program: '',
    clients: [],
    readonly: false,
    billingID: "",
    billings: [],
    newClient: "",
    newMonth: "",
    newYear: "",
    newStartDate: "",
    newEndDate: "",
    newReport: "",
    newCreatedBy: "",
    newStatus: "",
    PDFUrl: "",
    reports: [
      "Case Management Report",
      "Ancillary Report",
      "Residential Service Log Report"
    ],  
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    titleForm: "",

  }),

  computed: {
    
  },

  created() {
    this.getBilling();
  },

  methods: {
    initialize() {
      this.clients = [];
    },

    getStatusColor(status) {
      // Customize the colors based on status
      switch (status) {
          case 'Complete':
          return 'green';
          case 'Incomplete':
          return 'red';
          default:
          return 'blue'; // Default color if no match
      }
      },

    async getClients () {
      let params = {};
          let endpoint = `${url}/clients`;

          const companyIds = localStorage.getItem('userCompanies');

          params['Company:in'] = JSON.parse(companyIds);
          params['State'] = this.userState;

          await axios.get(endpoint,{params})
            .then((res) => {
                this.clients = res.data.clients;
            });  
    },

    updateBilling() {
          var req_body = {
              Status: this.newStatus
          };
          axios
              .put(`${url}/billings/${this.billingID}`, req_body)
              .then((response) => {
                  this.getBilling();
                  if (response.status == 400) {
                      response.json().then(function (data) {
                          alert(data.msg);
                      });
                  }
                  this.clear()
                  this.msg = true;
                  this.text = "The record has been updated successfully.";
              });
          this.close();
      },

    getBilling(){
      axios.get(`${url}/billings`).then(res => {
          this.billings = res.data.billings
      })
    },

    close() {
      this.dialog = false;
      this.clearFields();
    },
    

    downloadBillingReport(url) {
      let documentUrl = url

      if (documentUrl) {
          window.open(documentUrl, '_blank');
      } else {
          alert('No documents available');
      }
    },

    viewBillingReport(item) {
      this.titleForm= "Viewing Billing";
      this.dialog = true;
      this.editBilling = true;
      this.newBilling = false;
      this.newClient = item.Client.Name;
      this.newMonth = item.Month;
      this.newYear = item.Year;
      this.newStartDate = item.StartDate;
      this.newEndDate = item.EndDate;
      this.newReport = item.Report;
      this.newStatus = item.Status;
      this.newCreatedBy = item.CreatedBy;
      this.PDFUrl = item.PDFUrl;
      this.billingID = item._id;
    },

  fileSelected(e) {
    this.uploadFile=e;
  },

  saveFile() {
    this.message = "";
    if(!Array.isArray(this.uploadFile)){
      this.uploadFile = [this.uploadFile];
    }
    for (let i = 0; i < this.uploadFile.length; i++) {
      this.uploadFiles(this.uploadFile[i]);
    }
  },

  uploadFiles(file) {

    const formData = new FormData();
    formData.append('file', file);
    let ct = { headers:{"content-type" : "multipart/form-data"}};
    axios.post(`${url}/nevadaIncidents/fileUploader/${this.nvIncidentID}`,formData, ct)
        .then(res => {
          if(res){
            this.getIncidents();
          }
        })
        .catch(err => {
          console.log(err);
        });
  },

  clearFields() {
    this.newDocument = "";
    },

    downloadDocument(){
      window.open(this.newDocument);
    },


    printTable() {
      window.print()
  },
  
  async deleteBilling(item) {
    if (confirm('Are you sure you want to delete this billing entry?')) {
      try {
        await axios.delete(`${this.url}/billings/${item._id}`);
        this.getBilling();
        this.msg = true;
        this.text = "Billing entry deleted successfully.";
      } catch (error) {
        this.msg = true;
        this.text = "Failed to delete billing entry.";
      }
    }
  },
  
  }
}
</script>
<style>
#print {
display: none
}

@media only screen and (min-width: 768px) {
.mobile {
  display: none;
}
}

@media only screen and (max-width: 600px) {
.desktop {
  display: none;
}

}



@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

@media print { 
  #print{ 
  display: block; 
  border: none; 
  width: 1200px;
  padding-right: 300px;
  margin-left: -200px;

  }
  

  nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
    display: none;
    border: none; 

  }

  @page { margin: 0; }
  body { margin: 1.6cm; }

  
} 
</style>